import PropTypes from "prop-types";

// Layouts
import PayPlansFacade from "@PayPlans/Layouts/PayPlansFacade";

// Model
import PayPlansModel from "@PayPlans/models/Managers/Finance";

function Finance({ position = "F&I Manager", positionType = "Producer" }) {
	return (
		<PayPlansFacade
			position={position}
			positionType={positionType}
			defaultSections={["default", "backendPVRComputation"]}
			cacheManagement={{
				clearAbsoluteIndexes: [
					"programDetails",
					"models",
					"modelYears",
					"payPlanCsiMetrics",
					"payPlansSidebarTree",
					"payPlanSalesPerformanceReportVersions",
					"salesPerformanceProducts",
				],
			}}
		>
			<PayPlansModel />
		</PayPlansFacade>
	);
}
Finance.propTypes = {
	position: PropTypes.string,
	positionType: PropTypes.string,
};

export default Finance;
